import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";

const scrollTo = (id) => {
  const el = document.getElementById(id);
  if (el) el.scrollIntoView({ behavior: "smooth" });
};

const NavColumn = ({ header, items }) => (
  <div>
    <div
      style={{
        color: "#f7f8f8",
        fontSize: "11px",
        fontWeight: 600,
        letterSpacing: "0.6px",
        textTransform: "uppercase",
        marginBottom: "18px",
      }}
    >
      {header}
    </div>
    <div style={{ display: "flex", flexDirection: "column", gap: "10px" }}>{items}</div>
  </div>
);

const FooterLink = ({ label, onClick, href, external }) => {
  const baseStyle = {
    color: "#62666d",
    fontSize: "13px",
    background: "none",
    border: "none",
    padding: 0,
    cursor: "pointer",
    transition: "color 0.15s",
    textAlign: "left",
    display: "inline-flex",
    alignItems: "center",
    gap: "4px",
    textDecoration: "none",
  };
  const hoverIn = (e) => (e.currentTarget.style.color = "#d0d6e0");
  const hoverOut = (e) => (e.currentTarget.style.color = "#62666d");

  if (href) {
    return (
      <a
        href={href}
        target={external ? "_blank" : undefined}
        rel={external ? "noopener noreferrer" : undefined}
        style={baseStyle}
        onMouseEnter={hoverIn}
        onMouseLeave={hoverOut}
      >
        {label}
        {external && <span style={{ fontSize: "9px", opacity: 0.5 }}>↗</span>}
      </a>
    );
  }
  return (
    <button style={baseStyle} onClick={onClick} onMouseEnter={hoverIn} onMouseLeave={hoverOut}>
      {label}
    </button>
  );
};

const OfficeCard = ({ city, address }) => (
  <div style={{ display: "flex", flexDirection: "column", gap: "2px" }}>
    <span style={{ color: "#d0d6e0", fontSize: "12px", fontWeight: 500 }}>{city}</span>
    <span style={{ color: "#62666d", fontSize: "11px", lineHeight: 1.5 }}>{address}</span>
  </div>
);

// Social platforms — brand glyphs (simple-icons paths). Update href when the page exists.
const SOCIALS = [
  {
    name: "LinkedIn",
    href: "https://www.linkedin.com/company/mawered",
    path: "M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433a2.062 2.062 0 0 1-2.063-2.065 2.064 2.064 0 1 1 2.063 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.225 0z",
  } /*
  {
    name: "X",
    href: "#",
    path: "M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z",
  },
  {
    name: "Facebook",
    href: "#",
    path: "M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z",
  },
  {
    name: "Instagram",
    href: "#",
    path: "M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zM12 0C8.741 0 8.333.014 7.053.072 2.695.272.273 2.69.073 7.052.014 8.333 0 8.741 0 12c0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98C8.333 23.986 8.741 24 12 24c3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98C15.668.014 15.259 0 12 0zm0 5.838a6.162 6.162 0 100 12.324 6.162 6.162 0 000-12.324zM12 16a4 4 0 110-8 4 4 0 010 8zm6.406-11.845a1.44 1.44 0 100 2.881 1.44 1.44 0 000-2.881z",
  },
  {
    name: "YouTube",
    href: "#",
    path: "M23.498 6.186a3.016 3.016 0 00-2.122-2.136C19.505 3.545 12 3.545 12 3.545s-7.505 0-9.377.505A3.017 3.017 0 00.502 6.186C0 8.07 0 12 0 12s0 3.93.502 5.814a3.016 3.016 0 002.122 2.136c1.871.505 9.376.505 9.376.505s7.505 0 9.377-.505a3.015 3.015 0 002.122-2.136C24 15.93 24 12 24 12s0-3.93-.502-5.814zM9.545 15.568V8.432L15.818 12l-6.273 3.568z",
  },
  {
    name: "TikTok",
    href: "#",
    path: "M12.525.02c1.31-.02 2.61-.01 3.91-.02.08 1.53.63 3.09 1.75 4.17 1.12 1.11 2.7 1.62 4.24 1.79v4.03c-1.44-.05-2.89-.35-4.2-.97-.57-.26-1.1-.59-1.62-.93-.01 2.92.01 5.84-.02 8.75-.08 1.4-.54 2.79-1.35 3.94-1.31 1.92-3.58 3.17-5.91 3.21-1.43.08-2.86-.31-4.08-1.03-2.02-1.19-3.44-3.37-3.65-5.71-.02-.5-.03-1-.01-1.49.18-1.9 1.12-3.72 2.58-4.96 1.66-1.44 3.98-2.13 6.15-1.72.02 1.48-.04 2.96-.04 4.44-.99-.32-2.15-.23-3.02.37-.63.41-1.11 1.04-1.36 1.75-.21.51-.15 1.07-.14 1.61.24 1.64 1.82 3.02 3.5 2.87 1.12-.01 2.19-.66 2.77-1.61.19-.33.4-.67.41-1.06.1-1.79.06-3.57.07-5.36.01-4.03-.01-8.05.02-12.07z",
  },*/,
  {
    name: "GitHub",
    href: "https://github.com/Teknovat",
    path: "M12 .297c-6.63 0-12 5.373-12 12 0 5.303 3.438 9.8 8.205 11.385.6.113.82-.258.82-.577 0-.285-.01-1.04-.015-2.04-3.338.724-4.042-1.61-4.042-1.61C4.422 18.07 3.633 17.7 3.633 17.7c-1.087-.744.084-.729.084-.729 1.205.084 1.838 1.236 1.838 1.236 1.07 1.835 2.809 1.305 3.495.998.108-.776.417-1.305.76-1.605-2.665-.3-5.466-1.332-5.466-5.93 0-1.31.465-2.38 1.235-3.22-.135-.303-.54-1.523.105-3.176 0 0 1.005-.322 3.3 1.23.96-.267 1.98-.399 3-.405 1.02.006 2.04.138 3 .405 2.28-1.552 3.285-1.23 3.285-1.23.645 1.653.24 2.873.12 3.176.765.84 1.23 1.91 1.23 3.22 0 4.61-2.805 5.625-5.475 5.92.42.36.81 1.096.81 2.22 0 1.606-.015 2.896-.015 3.286 0 .315.21.69.825.57C20.565 22.092 24 17.592 24 12.297c0-6.627-5.373-12-12-12",
  },
];

const SocialIcon = ({ path }) => (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
    <path d={path} />
  </svg>
);

const UptimeDot = () => (
  <>
    <style>{`
      @keyframes mw-uptime-pulse {
        0%, 100% { box-shadow: 0 0 0 0 rgba(39,166,68,0.4); }
        70%       { box-shadow: 0 0 0 5px rgba(39,166,68,0); }
      }
      .mw-uptime { animation: mw-uptime-pulse 2.5s ease-in-out infinite; }
    `}</style>
    <div
      className="mw-uptime"
      style={{ width: "6px", height: "6px", borderRadius: "50%", backgroundColor: "#27a644", flexShrink: 0 }}
    />
  </>
);

const LandingFooter = () => {
  const navigate = useNavigate();
  const { i18n } = useTranslation();
  const lang = i18n.language;
  const t = (obj) => obj[lang] || obj.fr;

  return (
    <footer style={{ backgroundColor: "#010102", borderTop: "1px solid #23252a", padding: "72px 32px 0" }}>
      <div className="max-w-7xl mx-auto">
        {/* Main grid */}
        <div
          style={{ display: "grid", gridTemplateColumns: "2fr 1fr 1fr 1fr 1fr", gap: "48px", marginBottom: "64px" }}
          className="footer-grid"
        >
          <style>{`
            @media (max-width: 900px) {
              .footer-grid { grid-template-columns: 1fr 1fr !important; gap: 32px !important; }
            }
            @media (max-width: 600px) {
              .footer-grid { grid-template-columns: 1fr !important; }
            }
          `}</style>

          {/* Brand column */}
          <div>
            <div style={{ marginBottom: "16px" }}>
              <img
                src="/assets/brand/mawered-navbar-lockup.svg"
                alt="Mawered"
                style={{ height: "28px", width: "auto" }}
              />
            </div>
            <p style={{ color: "#62666d", fontSize: "13px", lineHeight: 1.7, maxWidth: "260px", marginBottom: "24px" }}>
              {t({
                fr: "La plateforme RH complète pour les entreprises EMEA. Paie multi-pays, présence biométrique, congés et gestion des talents.",
                en: "The complete HR platform for EMEA companies. Multi-country payroll, biometric attendance, leave and talent management.",
                ar: "منصة الموارد البشرية الشاملة لشركات EMEA. رواتب متعددة الدول وحضور بيومتري وإجازات وإدارة المواهب.",
              })}
            </p>

            {/* Offices */}
            <div style={{ display: "flex", flexDirection: "column", gap: "12px", marginBottom: "20px" }}>
              <OfficeCard
                city={t({ fr: "Tunisie", en: "Tunisia", ar: "تونس" })}
                address={t({ fr: "Avenue 20 Mars, Sousse", en: "Avenue 20 Mars, Sousse", ar: "شارع 20 مارس، سوسة" })}
              />
              <OfficeCard
                city={t({ fr: "Qatar", en: "Qatar", ar: "قطر" })}
                address={t({
                  fr: "QFC Tower 1, West Bay, Doha",
                  en: "QFC Tower 1, West Bay, Doha",
                  ar: "برج QFC 1، ويست باي، الدوحة",
                })}
              />
            </div>

            {/* Social */}
            <div style={{ display: "flex", gap: "8px", flexWrap: "wrap" }}>
              {SOCIALS.map((s) => (
                <a
                  key={s.name}
                  href={s.href}
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label={s.name}
                  title={s.name}
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    width: "32px",
                    height: "32px",
                    borderRadius: "8px",
                    backgroundColor: "#0f1011",
                    border: "1px solid #23252a",
                    color: "#62666d",
                    transition: "all 0.15s",
                    textDecoration: "none",
                  }}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.color = "#d0d6e0";
                    e.currentTarget.style.borderColor = "#34343a";
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.color = "#62666d";
                    e.currentTarget.style.borderColor = "#23252a";
                  }}
                >
                  <SocialIcon path={s.path} />
                </a>
              ))}
            </div>
          </div>

          {/* Product column */}
          <NavColumn
            header={t({ fr: "Produit", en: "Product", ar: "المنتج" })}
            items={[
              <FooterLink
                key="f"
                label={t({ fr: "Fonctionnalités", en: "Features", ar: "الميزات" })}
                onClick={() => scrollTo("features")}
              />,
              <FooterLink
                key="p"
                label={t({ fr: "Tarifs", en: "Pricing", ar: "الأسعار" })}
                onClick={() => scrollTo("pricing")}
              />,
              <FooterLink
                key="s"
                label={t({ fr: "Sécurité", en: "Security", ar: "الأمن" })}
                onClick={() => scrollTo("contact")}
              />,
              <FooterLink
                key="i"
                label={t({ fr: "Intégrations", en: "Integrations", ar: "التكاملات" })}
                onClick={() => scrollTo("features")}
              />,
              <FooterLink key="c" label="Changelog" onClick={() => {}} />,
            ]}
          />

          {/* Resources column */}
          <NavColumn
            header={t({ fr: "Ressources", en: "Resources", ar: "الموارد" })}
            items={[
              <FooterLink key="d" label={t({ fr: "Documentation", en: "Documentation", ar: "التوثيق" })} href="#" />,
              <FooterLink key="a" label="API Reference" href="#" external />,
              <FooterLink key="st" label="Status" href="#" external />,
              <FooterLink key="b" label="Blog" href="#" />,
              <FooterLink
                key="sp"
                label={t({ fr: "Support", en: "Support", ar: "الدعم" })}
                onClick={() => scrollTo("contact")}
              />,
            ]}
          />

          {/* Company column */}
          <NavColumn
            header={t({ fr: "Compagnie", en: "Company", ar: "الشركة" })}
            items={[
              <FooterLink key="ab" label={t({ fr: "À propos", en: "About", ar: "عن Mawered" })} href="#" />,
              <FooterLink key="co" label="Contact" onClick={() => scrollTo("contact")} />,
              <FooterLink key="pa" label={t({ fr: "Partenaires", en: "Partners", ar: "الشركاء" })} href="#" />,
              <FooterLink key="pr" label={t({ fr: "Presse", en: "Press", ar: "الصحافة" })} href="#" />,
              <FooterLink key="ca" label={t({ fr: "Carrières", en: "Careers", ar: "الوظائف" })} href="#" />,
            ]}
          />

          {/* Legal column */}
          <NavColumn
            header={t({ fr: "Légal", en: "Legal", ar: "القانوني" })}
            items={[
              <FooterLink
                key="t"
                label={t({ fr: "Conditions d'utilisation", en: "Terms of Service", ar: "شروط الخدمة" })}
                onClick={() => navigate("/terms")}
              />,
              <FooterLink
                key="p"
                label={t({ fr: "Confidentialité", en: "Privacy Policy", ar: "الخصوصية" })}
                onClick={() => navigate("/privacy")}
              />,
              <FooterLink key="ck" label="Cookies" href="#" />,
              <FooterLink key="e" label="contact@mawered.com" href="mailto:contact@mawered.com" />,
            ]}
          />
        </div>

        {/* Compliance strip */}
        <div
          style={{
            display: "flex",
            flexWrap: "wrap",
            gap: "10px",
            justifyContent: "center",
            marginBottom: "32px",
            paddingTop: "24px",
            borderTop: "1px solid #1a1b1e",
          }}
        >
          {[
            t({
              fr: "Conforme Code du Travail · TN",
              en: "Labour Law Compliant · TN",
              ar: "متوافق مع قانون العمل · تن",
            }),
            t({ fr: "CNSS · IR · IPP Tunisie", en: "CNSS · IR · IPP Tunisia", ar: "CNSS · IR · IPP تونس" }),
            t({ fr: "Qatar GOSI Ready", en: "Qatar GOSI Ready", ar: "جاهز لقطر GOSI" }),
            t({ fr: "HTTPS/TLS · Bcrypt · RBAC", en: "HTTPS/TLS · Bcrypt · RBAC", ar: "HTTPS/TLS · Bcrypt · RBAC" }),
            t({ fr: "99.9% SLA Uptime", en: "99.9% SLA Uptime", ar: "99.9% وقت تشغيل SLA" }),
          ].map((label, i) => (
            <span
              key={i}
              style={{
                display: "inline-flex",
                alignItems: "center",
                padding: "3px 10px",
                borderRadius: "9999px",
                backgroundColor: "#0f1011",
                border: "1px solid #23252a",
                color: "#62666d",
                fontSize: "11px",
                fontWeight: 400,
              }}
            >
              {label}
            </span>
          ))}
        </div>

        {/* Bottom bar */}
        <div
          style={{
            display: "flex",
            flexWrap: "wrap",
            justifyContent: "space-between",
            alignItems: "center",
            gap: "12px",
            padding: "20px 0",
            borderTop: "1px solid #1a1b1e",
          }}
        >
          <div style={{ display: "flex", alignItems: "center", gap: "16px" }}>
            <div style={{ color: "#62666d", fontSize: "12px" }}>
              © 2026 Teknovat · Mawered.{" "}
              {t({ fr: "Tous droits réservés.", en: "All rights reserved.", ar: "جميع الحقوق محفوظة." })}
            </div>
            <div style={{ display: "flex", alignItems: "center", gap: "5px" }}>
              <UptimeDot />
              <span style={{ color: "#62666d", fontSize: "11px" }}>
                {t({ fr: "Tous les systèmes opérationnels", en: "All systems operational", ar: "جميع الأنظمة تعمل" })}
              </span>
            </div>
          </div>

          {/* Language switcher */}
          <div className="flex items-center gap-1">
            {["fr", "en", "ar"].map((l) => (
              <button
                key={l}
                onClick={() => i18n.changeLanguage(l)}
                style={{
                  padding: "3px 10px",
                  borderRadius: "9999px",
                  fontSize: "11px",
                  fontWeight: 500,
                  textTransform: "uppercase",
                  cursor: "pointer",
                  transition: "all 0.15s",
                  backgroundColor: lang === l ? "#0f1011" : "transparent",
                  color: lang === l ? "#d0d6e0" : "#62666d",
                  border: lang === l ? "1px solid #23252a" : "1px solid transparent",
                }}
              >
                {l}
              </button>
            ))}
          </div>
        </div>
      </div>
    </footer>
  );
};

export default LandingFooter;
